import types from './types';
import { t } from 'i18next';

export default ({ type }) => {
  switch (type) {
    case types.DOWNLOAD_FILE_FAILURE:
		case types.DOWNLOAD_FILE_AS_BA_FAILURE:
			return {
        title: t('message.title.error.download.file'),
        type: 'error'
      };
    default:
      return false;
  }
};
